"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JamoBlock = void 0;
var JamoConstants_1 = require("./JamoConstants");
var throwIfNotJamo_1 = __importDefault(require("./utlils/throwIfNotJamo"));
/**
 * 자음, 모음을 판단하고 조합합니다.
 */
var JamoBlock = /** @class */ (function () {
    function JamoBlock(inputChar) {
        throwIfNotJamo_1.default(inputChar);
        this._character = inputChar;
    }
    Object.defineProperty(JamoBlock.prototype, "character", {
        /** 자모 글자 */
        get: function () {
            return this._character;
        },
        enumerable: false,
        configurable: true
    });
    JamoBlock.prototype.isConsonant = function () {
        return JamoConstants_1.JamoConstants.consonants.includes(this._character);
    };
    JamoBlock.prototype.isVowel = function () {
        return JamoConstants_1.JamoConstants.vowels.includes(this._character);
    };
    JamoBlock.prototype.isInitialConsonant = function () {
        return JamoConstants_1.JamoConstants.initialConsonants.includes(this._character);
    };
    JamoBlock.prototype.isMedialVowel = function () {
        return JamoConstants_1.JamoConstants.medialVowels.includes(this._character);
    };
    JamoBlock.prototype.isFinalConsonant = function () {
        return JamoConstants_1.JamoConstants.finalConsonats.includes(this._character);
    };
    /**
     * 합성 모음인지?
     */
    JamoBlock.prototype.isComposedVowel = function () {
        return JamoConstants_1.JamoConstants.vowelMapForDecomposition.has(this._character);
    };
    /**
     * 모음을 합성할 수 있는지?
     * @param input 합성할 모음
     * @returns 가능 여부
     */
    JamoBlock.prototype.canComposedVowel = function (input) {
        throwIfNotJamo_1.default(input);
        return JamoConstants_1.JamoConstants.vowelMapForComposition.has("" + this._character + input);
    };
    /**
     * 합성한 종성 자음인지?
     * @returns 가능 여부
     */
    JamoBlock.prototype.isComposedFinalConsonats = function () {
        return JamoConstants_1.JamoConstants.finalConsonatMapForDecomposition.has(this._character);
    };
    /**
     * 종성 자음을 합성할 수 있는지?
     * @param input 합성할 자모
     * @returns 가능 여부
     */
    JamoBlock.prototype.canComposeFinalConsonants = function (input) {
        throwIfNotJamo_1.default(input);
        return JamoConstants_1.JamoConstants.finalConsonatMapForComposition.has("" + this._character + input);
    };
    JamoBlock.prototype.canComposeCharacter = function (input) {
        throwIfNotJamo_1.default(input);
        return (this.canComposeFinalConsonants(input) || this.canComposedVowel(input));
    };
    JamoBlock.prototype.generateComposedCharacter = function (input) {
        throwIfNotJamo_1.default(input);
        if (this.canComposedVowel(input)) {
            return JamoConstants_1.JamoConstants.vowelMapForComposition.get("" + this._character + input);
        }
        if (this.canComposeFinalConsonants(input)) {
            return JamoConstants_1.JamoConstants.finalConsonatMapForComposition.get("" + this._character + input);
        }
        throw new Error(this._character + "\uC640 " + input + "\uC744 \uD569\uC131\uC744 \uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
    };
    /**
     * 자모를 분해합니다.
     * @returns 분해된 자모 목록
     */
    JamoBlock.prototype.decompose = function () {
        var vowels = JamoConstants_1.JamoConstants.vowelMapForDecomposition.get(this._character);
        if (vowels)
            return vowels.split("");
        var consonants = JamoConstants_1.JamoConstants.finalConsonatMapForDecomposition.get(this._character);
        if (consonants)
            return consonants.split("");
        return [this._character];
    };
    return JamoBlock;
}());
exports.JamoBlock = JamoBlock;
